import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FAQ() {
  const [openId, setOpenId] = useState<number | null>(null);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section className="py-14 md:py-20 bg-background-50" id="faq">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            关于爱爱网，您可能想了解的问题
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/60 rounded-xl overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => setOpenId(openId === item.id ? null : item.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer whitespace-nowrap"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">{item.question}</span>
                <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openId === item.id ? 'rotate-180 bg-primary-100 text-primary-600' : 'bg-background-200/70 text-foreground-400'}`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              </button>
              {openId === item.id && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}